import React, { ExoticComponent, Fragment, ReactNode, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Group from 'react-bootstrap/Form';
import { Form as BootstrapForm } from 'react-bootstrap';
import { FormikErrors, Form } from 'formik';
import { FormattedMessage } from 'react-intl';
import Alert from 'react-bootstrap/Alert';
import SubmitButton from '../components/submit-button';
import ErrorMessage from '../components/error-message';
import { FieldLabel } from '../components/fields/base';

interface EditExpiryDateProps {
  bodyContainer: ExoticComponent<{ children?: ReactNode }>;
  actionsContainer: ExoticComponent<{ children?: ReactNode }>;
  renderSecondaryAction: any;
  errors: FormikErrors<any>;
  values: { date: string };
  setFieldValue: (name: string, value: string) => void;
  isSubmitting: boolean;
  isValid: boolean;
  validateForm: () => void;
}

const EditExpiryDateForm = ({
  bodyContainer: BodyContainer = Fragment,
  actionsContainer: ActionsContainer = Fragment,
  renderSecondaryAction,
  errors,
  isSubmitting,
  isValid,
  values,
  setFieldValue,
  validateForm,
}: EditExpiryDateProps) => {
  useEffect(() => {
    validateForm();
  }, []);

  return (
    <Form noValidate>
      <BodyContainer>
        {errors._general && (
          <Alert variant="danger">
            <ErrorMessage>{errors._general}</ErrorMessage>
          </Alert>
        )}

        <Row>
          <Col lg={12}>
            <Group>
              <FieldLabel>Expiry Date</FieldLabel>
              <BootstrapForm.Control
                type="date"
                value={values.date || ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('date', e.target.value);
                }}
                id="expiry-date"
                className="form-control"
              />
            </Group>
          </Col>
        </Row>
      </BodyContainer>

      <ActionsContainer>
        {renderSecondaryAction && renderSecondaryAction()}
        <SubmitButton
          label={<FormattedMessage id="id.save-expiry-date" defaultMessage="Save" />}
          disabled={isSubmitting || !isValid}
          isSubmitting={isSubmitting}
        />
      </ActionsContainer>
    </Form>
  );
};

export default EditExpiryDateForm;
